import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'
import type { CrmPageProps } from '@/lib/crm-page'

import AppShell from '@/components/generals/app-shell'
import PageHeader from '@/components/generals/page-header'
import ContactsView from '@/components/contacts/contacts-view'
import { loadCrmPageProps } from '@/lib/crm-page'

const ContactsPage: FC<Partial<CrmPageProps>> = ({ data, today }): ReactNode => {
    return (
        <AppShell data={data} today={today ?? ''} title="Contacts" description="The people you work with at every account.">
            <PageHeader title="Contacts" />
            <ContactsView />
        </AppShell>
    )
}

export const getServerSideProps: GetServerSideProps<CrmPageProps> = async () => {
    return { props: await loadCrmPageProps() }
}

export default ContactsPage
